/*
 * Collapsible behaviour for converted Replo sections.
 *
 * Replo's runtime drove these accordions; the conversion removes that runtime,
 * so this reproduces exactly the contract its CSS already expects:
 *
 *   [data-replo-collapsible]           data-state="open" | "closed"
 *     [role=button][aria-expanded]     the trigger
 *     .replo-animated[data-state]      the panel, animated by slideDown/slideUp
 *
 * Deliberately matches Replo's existing markup rather than introducing <details>,
 * so the converted sections stay pixel-identical to what shipped before.
 */
(function () {
  'use strict';

  var ROOT = '[data-replo-collapsible]';

  function panelFor(root, trigger) {
    var id = trigger.getAttribute('aria-controls');
    if (id) {
      // ids from Replo contain ':' which is invalid in a CSS selector,
      // so getElementById rather than querySelector
      var byId = document.getElementById(id);
      if (byId) return byId;
    }
    // Replo renders the panel as the sibling immediately after the trigger.
    // There is no .replo-animated wrapper in this markup - that class only
    // appears in the stylesheet - so matching on it finds nothing.
    return trigger.nextElementSibling;
  }

  function setState(root, trigger, open) {
    var panel = panelFor(root, trigger);
    var state = open ? 'open' : 'closed';
    root.setAttribute('data-state', state);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!panel) return;
    // `hidden` is what actually collapses it; data-state drives the animation
    // where a .replo-animated wrapper is present.
    if (open) {
      panel.removeAttribute('hidden');
      panel.setAttribute('data-state', 'open');
    } else {
      panel.setAttribute('data-state', 'closed');
      panel.setAttribute('hidden', '');
    }
  }

  function toggle(root, trigger) {
    setState(root, trigger, trigger.getAttribute('aria-expanded') !== 'true');
  }

  function init(root) {
    if (root.dataset.collapsibleBound === 'true') return;
    var trigger = root.querySelector('[role="button"][aria-expanded]');
    if (!trigger) return;
    root.dataset.collapsibleBound = 'true';

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      toggle(root, trigger);
    });

    // role=button elements do not get keyboard activation for free
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle(root, trigger);
      }
    });
  }

  function scan() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', scan);
})();
